import React from 'react';
import cl from './MyPagination.module.css'
import left from '../../../Assets/icons/chevron_left.svg'
import right from '../../../Assets/icons/chevron_right.svg'

const MyPagination = ({totalPages, currentPage, onPageChange}) => {
    if (totalPages<2) return;
    const getPages = () => {
        const pages = [];
        const showDots = totalPages > 5;

        if (showDots) {
            pages.push(1); // Всегда показываем первую страницу

            if (currentPage > 3) pages.push("...");

            for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 2) pages.push("...");

            pages.push(totalPages); // Всегда показываем последнюю страницу
        } else {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        }
        return pages;
    };

    return (
        <div className={cl.pagination}>
            <button
                className={cl.navBtn}
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <img src={left} alt={"to the left"}/>
            </button>
            <div className={cl.pageWrap}>
                {getPages().map((page, index) => (
                    <button
                        key={index}
                        className={`${cl.pagBtn} ${page === currentPage ? cl.active : ""}`}
                        onClick={() => typeof page === "number" && onPageChange(page)}
                        disabled={typeof page !== "number"}
                    >
                        {page}
                    </button>
                ))}
            </div>
            <button
                className={cl.navBtn}
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                <img src={right} alt={"to the left"}/>
            </button>
        </div>
    );
};

export default MyPagination;